import React, { useState } from 'react';

import './Faq.scss';

export default function Faq(props) {
  const [searchResults, updateSeachResults] = useState({});

  return (
    <section id="faq">
      <h2 id="faq_title">Veelgestelde vragen</h2>

      <p>
        Hieronder vind je een overzicht van de onderwerpen waarover veel vragen
        worden gesteld. Klik op de link bij het onderwerp arover je een vraag
        hebt om de vragen en antwoorden te zien.
      </p>

      <form
        id="faq_form"
        onKeyUp={(e) => search(e)}
        onSubmit={(e) => e.preventDefault()}
      >
        <input
          type="text"
          name="search"
          autoComplete="off"
          placeholder="Zoek op woord, vraag of begrip..."
        />
      </form>

      <div id="faq_content">
        <ul id="faq_content_main">
          {props.categories.map((category, idx) => {
            const currentCategory =
              searchResults.results &&
              searchResults.results.find(
                (item) => item.title === category.title
              );

            const replacedText = currentCategory && replace(category.title);

            return (
              <li key={idx}>
                <span
                  className="faq_anchor"
                  id={`${category.title.toLowerCase().replace(' ', '-')}`}
                ></span>

                {replacedText ? (
                  <p
                    className="faq_category_title"
                    dangerouslySetInnerHTML={{ __html: replacedText }}
                  ></p>
                ) : (
                  <p className="faq_category_title">{category.title}</p>
                )}

                <ul className="faq_category_questions">
                  {category.entries.map((entry, idx) =>
                    categoryQuestions(entry, idx)
                  )}
                </ul>
              </li>
            );

            function categoryQuestions(item, idx) {
              const currentQuestion =
                currentCategory &&
                currentCategory.entries.find(
                  (entry) => entry.question === item.question
                );

              const replacedText = currentQuestion && replace(item.question);

              return (
                <li className="faq_category_question" key={idx}>
                  <span
                    onClick={(e) => toggleAnswer(e)}
                    className="faq_category_plus"
                  ></span>

                  {replacedText ? (
                    <p
                      onClick={(e) => toggleAnswer(e)}
                      dangerouslySetInnerHTML={{ __html: replacedText }}
                    ></p>
                  ) : (
                    <p onClick={(e) => toggleAnswer(e)}>{item.question}</p>
                  )}

                  <p className="faq_category_answer">{item.answer}</p>
                </li>
              );
            }
          })}
        </ul>

        <div id="faq_navigation">
          <p id="faq_navigation_title">Categorieën</p>

          <ul id="faq_navigation_list">
            {props.categories.map((category, idx) => (
              <li key={idx}>
                <a href={`#${category.title.toLowerCase().replace(' ', '-')}`}>
                  {category.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );

  function search(e) {
    const value = e.target.value.trim();

    if (!value) return updateSeachResults({});

    const regexp = new RegExp(value, 'ig');

    const results = props.categories.filter(
      (category) =>
        category.title.match(regexp) ||
        category.entries.find((entry) => entry.question.match(regexp))
    );

    updateSeachResults({ request: value.toLowerCase(), results });
  }

  function replace(item) {
    return item.replace(
      new RegExp(searchResults.request, 'ig'),
      (str) => `<span class="faq_search_result">${str}</span>`
    );
  }
}

function toggleAnswer(e) {
  e.target
    .closest('.faq_category_question')
    .classList.toggle('faq_category_question_folder_out');
}
